/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
export const SAVE_WMI_CREDENTIALS = 'SAVE_WMI_CREDENTIALS'
export const SAVE_WMI_CREDENTIALS_SUCCESS = 'SAVE_WMI_CREDENTIALS_SUCCESS'
export const SAVE_WMI_CREDENTIALS_FAILURE = 'SAVE_WMI_CREDENTIALS_FAILURE'
	
export const EDIT_WMI_CREDENTIALS = 'EDIT_WMI_CREDENTIALS'
export const EDIT_WMI_CREDENTIALS_SUCCESS = 'EDIT_WMI_CREDENTIALS_SUCCESS'
export const EDIT_WMI_CREDENTIALS_FAILURE = 'EDIT_WMI_CREDENTIALS_FAILURE'
	
export const SAVE_UNIX_CREDENTIALS = 'SAVE_UNIX_CREDENTIALS'
export const SAVE_UNIX_CREDENTIALS_SUCCESS = 'SAVE_UNIX_CREDENTIALS_SUCCESS'
export const SAVE_UNIX_CREDENTIALS_FAILURE = 'SAVE_UNIX_CREDENTIALS_FAILURE'
			
export const EDIT_UNIX_CREDENTIALS = 'EDIT_UNIX_CREDENTIALS'
export const EDIT_UNIX_CREDENTIALS_SUCCESS = 'EDIT_UNIX_CREDENTIALS_SUCCESS'
export const EDIT_UNIX_CREDENTIALS_FAILURE = 'EDIT_UNIX_CREDENTIALS_FAILURE'
	
export const GET_WMI_CREDENTIALS = 'GET_WMI_CREDENTIALS'
export const FETCH_WMI_CREDENTIALS_SUCCESS = 'FETCH_WMI_CREDENTIALS_SUCCESS'
export const FETCH_WMI_CREDENTIALS_FAILURE = 'FETCH_WMI_CREDENTIALS_FAILURE'

export const POLL_WMI_START = 'POLL_WMI_START'
export const POLL_WMI_STOP = 'POLL_WMI_STOP'

export const GET_UNIX_CREDENTIALS = 'GET_UNIX_CREDENTIALS'
export const FETCH_UNIX_CREDENTIALS_SUCCESS = 'FETCH_UNIX_CREDENTIALS_SUCCESS'
export const FETCH_UNIX_CREDENTIALS_FAILURE = 'FETCH_UNIX_CREDENTIALS_FAILURE'
	
export const POLL_UNIX_START = 'POLL_UNIX_START'
export const POLL_UNIX_STOP = 'POLL_UNIX_STOP'
	
export const DELETE_UNIX_CRED = 'DELETE_UNIX_CRED'
export const UPDATE_UNIX_CRED = 'UPDATE_UNIX_CRED'
export const ADDED_UNIX_CRED = 'ADDED_UNIX_CRED'